import React from 'react'
import { CalendarExercises as C } from '../../features/calendar/CalendarExercise'
import { RouteProps } from '../../routes/AppRouter'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

type CalendarExerciseProps = {
  id?: string
  selectedDate?: Date
} & RouteProps

export function CalendarExercise(props: CalendarExerciseProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)
  const state: CalendarExerciseProps = props.location?.state as CalendarExerciseProps

  return <C id={props.id} selectedDate={state?.selectedDate} />
}
